import React from 'react';
import { inject } from 'mobx-react';
import { observer } from 'mobx-react-lite';
import { AvailabilityBusiness } from '@business/newCreateRequest/stepsItems/availability';
import { Button } from 'oned';
import { AvailAbilityStep, AvailabilityTimesSubTitle, AvailabilityTimesTitle } from '@common/enums/availability';
import AvailabilityOptions from './availabilityOptions';
import AvailabilitySelected from './availabilitySelected';
var NewAvailabilityTimes = inject(AvailabilityBusiness)(observer(function (props) {
    var availabilityStep = props.availabilityStep, setAvailabilityParams = props.setAvailabilityParams, slaStartTime = props.slaStartTime;
    var TimesTitle = function () {
        if (availabilityStep === AvailAbilityStep.FlexibleTime) {
            return AvailabilityTimesTitle.FlexibleTimeTitle;
        }
        if (availabilityStep === AvailAbilityStep.LimitedTime) {
            return AvailabilityTimesTitle.LimitedTimeTitle;
        }
    };
    var TimesSubTitle = function () {
        if (availabilityStep === AvailAbilityStep.FlexibleTime) {
            return AvailabilityTimesSubTitle.FlexibleTimeSubTitle;
        }
        if (availabilityStep === AvailAbilityStep.LimitedTime) {
            return AvailabilityTimesSubTitle.LimitedTimeSubTitle;
        }
    };
    return React.createElement(React.Fragment, null,
        React.createElement("h2", null,
            React.createElement("b", { className: 'title' }, TimesTitle())),
        React.createElement("div", { className: 'pt-0 ft-16' }, TimesSubTitle()),
        slaStartTime && React.createElement("div", { className: 'd-flex row no-gutters' },
            React.createElement("div", { className: 'col-md-5 col-xs-12' },
                React.createElement("div", { className: 'availability-options' },
                    React.createElement(AvailabilityOptions, null))),
            React.createElement("div", { className: 'col-md-7 col-xs-12' },
                React.createElement("div", { className: 'availability-selected-item' },
                    React.createElement(AvailabilitySelected, null)))),
        React.createElement("div", { className: 'pt-5' },
            React.createElement(Button, { type: 'link', block: true, tag: 'Skip', onClick: function () {
                    setAvailabilityParams('isSkip', true);
                } }, "Skip")));
}));
export default NewAvailabilityTimes;
